<template>
  <section class="Recommend-root" @click="jumpToHref">
    <div class="recommend-c">
      <h1 class="u-h1">
        <h2 class="cn animate__flipInY animate__animated animate__slow">
          我要定制
        </h2>
        <h4 class="en animate__fadeInUp animate__animated animate__slow">
          I WANT TO CUSTOMIZE IT
        </h4>
      </h1>
      <div class="form">
        <Input v-model="form.demand" class="input" placeholder="请描述您的开发需求，例如：电商APP" readonly style="width: 490px" />
        <Input v-model="form.phone" class="input" placeholder="手机号码" readonly style="width: 328px" />
        <Button class="bottom" type="primary" shape="circle" style="width: 240px">获取报价</Button>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name       : 'Recommend',
  components : {},
  props      : {},
  data(){
    return {
      form:{
        phone:'手机号码',
        demand:'请描述您的开发需求，例如：电商APP'
      }
    };
  },
  computed   : {},
  created(){},
  methods    : {
    jumpToHref(){
      location.href = this.$api.domainName + 'quotation.html';
    }
  },
};
</script>
<style scoped lang="scss">
.Recommend-root{
  background: url("../assets/customization-bg.png");
  background-size: 100% auto;
  background-position: 50% 0;
  height: 264px;
  width: 100%;
  .u-h1{
    padding: 50px 0 34px;
  }
  .form{
    display: flex;
    align-items: center;
    justify-content: center;
    .input{
      /deep/ .ivu-input{
        font-size: 24px;
        height: 50px;
        border-radius: 6px;
      }
      &:not(:first-child){
        margin-left: 14px;
      }
      box-shadow: 0px 9px 18px 2px rgba(64, 119, 255, 0.18);
    }
    .bottom{
      margin-left: 26px;
      font-size: 24px;
      height: 50px;
    }
  }
}
</style>
